import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import TransactionsTable from "components/Doobi/Transactions";

const TransactionsRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Transactions" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={TransactionsTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default TransactionsRoute;
